import type { MiddlewareFunction } from "@segment/analytics-next";
import { effectiveReferrer } from "./effectiveReferrer";

/**
 * Segment source middleware that undoes the referrer a Cloudflare challenge
 * overwrote. Applied to every outgoing event, because Segment attaches
 * `context.page.referrer` to all of them rather than only to pageviews.
 */
export const restoreReferrer: MiddlewareFunction = ({ payload, next }) => {
  const page = payload.obj.context?.page;

  if (page) {
    page.referrer = effectiveReferrer({
      documentReferrer: page.referrer ?? "",
      serverReferrer: window.serverReferrer,
    });
  }

  next(payload);
};
